import React from "react";
import { Helmet } from "react-helmet-async";
import "./App.css";
import Header from "./components/Header";
import Banner from "./components/Banner";
import Services from "./components/Services";
import Transformation from "./components/Transformation";
import AboutGreen from "./components/AboutGreen";
import TestimonialsCarousel from "./components/TestimonialsCarousel";
import Pricing from "./components/Pricing";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Helmet>
        <title>GreenScape Landscaping | Expert Lawn & Garden Care</title>
        <meta
          name="description"
          content="Professional landscaping services including lawn maintenance, garden design, hardscape installation, and seasonal clean-ups. We transform outdoor spaces into lush, vibrant environments."
        />
        <link
          rel="canonical"
          href="https://websolutionusa.com/templates/landscaping/"
        />
        <meta
          property="og:title"
          content="GreenScape Landscaping | Expert Lawn & Garden Care"
        />
        <meta
          property="og:description"
          content="From garden redesign to routine maintenance, our team delivers premium outdoor solutions to keep your property looking its best year-round."
        />
        <meta property="og:type" content="website" />
      </Helmet>
      <Header />
      <Banner />
      <Services />
      <Transformation />
      <AboutGreen />
      <TestimonialsCarousel />
      <Pricing />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
